import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "../src/Context/AuthContext";
import { ThemeProvider } from "./Context/ThemeContext";
import { RoleProvider } from "./Context/RoleContext";
import "bootstrap/scss/bootstrap.scss";
import { suppressConsole } from "./utils/console";
import "./index.scss";

// Suppress console logs in production environment
// suppressConsole();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <AuthProvider>
      <RoleProvider>
        <App />
      </RoleProvider>
    </AuthProvider>
  </ThemeProvider>,
);

reportWebVitals();
